import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { useTranslation } from "@/lib/i18n.jsx";

export const SplashScreen = ({ onComplete }) => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlTheme = params.get("theme");

    if (urlTheme === "light") {
      setTheme("light");
    } else {
      setTheme("dark");
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof onComplete === 'function') {
        onComplete();
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={`splash-screen ${theme}`}>
      <div className="splash-content">
        <div className="splash-brand">
          <picture>
            <source
              srcSet={theme === "light" ? "/mainlogoblack.webp" : "/mainlogo.webp"}
              type="image/webp"
            />
            <img
              src={theme === "light" ? "/mainlogoblack.png" : "/mainlogo.png"}
              alt="Palzea"
              className="h-12 w-auto"
            />
          </picture>
        </div>

        <div className="dot-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className="splash-powered">
          <Zap className="w-3 h-3" />
          <span>{t('widget.splash.tagline', 'Secure • Fast • Reliable')}</span>
        </div>
      </div>

      <div className="splash-bg-gradient" />
      <div className="splash-bg-particles">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="splash-particle"
            style={{ "--delay": `${i * 0.2}s` }}
          />
        ))}
      </div>
    </div>
  );
};
